import { render, staticRenderFns } from "./programmeAdd.vue?vue&type=template&id=07091395&scoped=true&"
import script from "./programmeAdd.vue?vue&type=script&lang=js&"
export * from "./programmeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07091395",
  null
  
)

export default component.exports